/* eslint-disable prettier/prettier */
import { history as historyRouter } from 'instantsearch.js/es/lib/routers';
import localize from './localize';
import refinements from './refinements';

export default {
  router: historyRouter({
    createURL({ qsModule, routeState, location }) {
      const urlParts = location.href.match(/^(.*?)/);
      const baseUrl = `${
        urlParts ? location.toString().replace(location.search, '') : ''
      }`;
      const queryParameters = {};

      if (routeState.query) {
        queryParameters.query = routeState.query;
      }
      if (routeState.page !== 1) {
        queryParameters.page = routeState.page;
      }
      if (routeState.refinementList) {
        queryParameters.refinementList =
          routeState.refinementList && routeState.refinementList;
      }

      const queryString = qsModule.stringify(queryParameters, {
        addQueryPrefix: true,
        arrayFormat: 'repeat',
      });

      return `${baseUrl}${queryString}`;
    },

    parseURL({ qsModule, location }) {
      var { query = '', refinementList = refinements } = qsModule.parse(
        location.search.slice(1)
      );

      var paramStr = location.search;
      // if (paramStr != '') {
      //   var params = paramStr.substring(1, paramStr.length).split('&');
      //   var jsonObj = [];
      //   for (var index = 0; index < params.length; index++) {
      //     var param = params[index].split('=');
      //     if (param[0] != '') {
      //       var the_key = decodeURIComponent(param[0]).replace(
      //         'refinementList[',
      //         ''
      //       );
      //       the_key = the_key.replace(']', '');
      //       if (!jsonObj[the_key]) {
      //         jsonObj[the_key] = [];
      //       }
      //       jsonObj[the_key].push(decodeURIComponent(param[1]));
      //     }
      //   }
      //   refinementList = { ...jsonObj };
      // }

      let str2 = 'refinementList';
      if (paramStr != '' && paramStr.indexOf(str2) != -1) {
        var params = paramStr.substring(1, paramStr.length).split('&');

        var jsonObj = [];

        for (var index = 0; index < params.length; index++) {
          var param = params[index].split('=');

          if (param[0] != '' && param[0] != 'gclid') {
            var the_key = decodeURIComponent(param[0]).replace(
              'refinementList[',
              ''
            );
            the_key = the_key.replace(']', '');
            if (!jsonObj[the_key]) {
              jsonObj[the_key] = [];
            }
            jsonObj[the_key].push(decodeURIComponent(param[1]));
          }
        }
        refinementList = { ...jsonObj };
      }

      return {
        query: decodeURIComponent(query),
        refinementList,
      };
    },
  }),

  stateMapping: {
    stateToRoute(uiState) {
      const indexUiState = localize('svb_jobs_index')
        ? uiState[localize('svb_jobs_index')]
        : {};

      return {
        query: indexUiState.query,
        page: indexUiState.page,
        refinementList: indexUiState.refinementList,
      };
    },

    routeToState(routeState) {
      return {
        [localize('svb_jobs_index') || '']: {
          query: routeState.query,
          page: routeState.page,
          refinementList: routeState.refinementList,
        },
      };
    },
  },
};
